import React from "react";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import moment from "moment";

// estilos
import "./pptosNew.css";
import { IconButton, Tooltip } from "@mui/material";
import { ArrowLeftRight } from "lucide-react";

const solesFormat = new Intl.NumberFormat("es-PE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const exchangeRateFormat = new Intl.NumberFormat("es-PE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 12,
});

// const params = {
//     rent_optima: 30,
//     rent_media: 25,
//     rent_baja: 10,
// }

export const PptosListaitem = ({ p, access }) => {
  return (
    <tr className="p-tr-body-global" key={p.id}>
      <td className="text-center">
        <Link
          className="LinkTable d-flex flex-column justify-content-center align-items-center"
          to={`/ppto/${p.id}
                    `}
        >
          <span>#{p.numero}</span>
          {p.estado_negocio === "anulado" && (
            <div className="flex flex-col justify-center content-center items-center">
              <span
                className="p-label-anulado text-center"
                title={p.descripcion_motivo_anulacion}
              >
                {p.estado_negocio}
              </span>
              <span className="lowercase first-letter:uppercase text-[13px]">
                Motivo: {p.descripcion_motivo_anulacion}
              </span>
            </div>
          )}
        </Link>
      </td>
      <td
        className="text-center"
        title={moment(p.fecha_asignacion).format("DD-MM-YYYY")}
      >
        <Link className="LinkTable" to={`/ppto/${p.id}`}>
          {moment(p.fecha_asignacion).format("MMM YYYY")}
        </Link>
      </td>
      <td className="text-clientes text-start sticky left-0 z-10 bg-white">
        <Link className="LinkTable" to={`/ppto/${p.id}`}>
          {p.referencia || "---"}
        </Link>
      </td>
      <td className="text-clientes text-start">
        <Link className="LinkTable" to={`/ppto/${p.id}`}>
          {p.cliente || "---"}
        </Link>
      </td>
      <td className="text-end">
        <Link className="LinkTable" to={`/ppto/${p.id}`}>
          <NumberFormat
            value={p.total_neto ? parseFloat(p.total_neto) : 0}
            displayType={"text"}
            thousandSeparator={p.separacion_miles || ","}
            decimalSeparator={p.separacion_decimales || "."}
            decimalScale={2}
            prefix={`${p.simbolo} `}
            fixedDecimalScale
          />
        </Link>

        {Number(p.id_moneda) === 4 && p.total_neto_soles != null && (
          <Tooltip
            title={`Equivalente: S/ ${solesFormat.format(Number(p.total_neto_soles))} · TC: S/ ${exchangeRateFormat.format(Number(p.applied_exchange_rate))} por dólar${p.default_exchange_rate ? " (predeterminado)" : ""}`}
            arrow
            enterTouchDelay={0}
          >
            <IconButton
              size="small"
              aria-label="Ver conversión a soles"
              sx={{ color: "var(--primary-color)", ml: 0.5, p: 0.25 }}
            >
              <ArrowLeftRight size={12} strokeWidth={1.75} aria-hidden="true" />
            </IconButton>
          </Tooltip>
        )}

        {/* <br />
                <span className='ms-1'>
                    <span className='me-2'>{parseFloat(p.valor_tipo_cambio) || '--'}</span>
                    <NumberFormat
                        value={(p.total_neto * p.valor_tipo_cambio) || 0}
                        displayType={'text'}
                        thousandSeparator={p.separacion_miles}
                        decimalSeparator={p.separacion_decimales}
                        decimalScale={2}
                        prefix={`S/ `}
                        fixedDecimalScale
                    />
                </span> */}
      </td>

      {access.a21 && (
        <td className="text-center">
          <Link className="LinkTable" to={`/ppto/${p.id}`}>
            {p.rentabilidad_p >= p.validacion_rentabilidad_optima && (
              <NumberFormat
                className="p-pptos-rent-aprobado"
                value={p.rentabilidad_p ? parseFloat(p.rentabilidad_p) : 0}
                displayType={"text"}
                thousandSeparator={","}
                decimalSeparator="."
                decimalScale={2}
                suffix="%"
                fixedDecimalScale
              />
            )}
            {p.rentabilidad_p < p.validacion_rentabilidad_optima && (
              <NumberFormat
                className="p-pptos-rent-porvalidar"
                value={p.rentabilidad_p ? parseFloat(p.rentabilidad_p) : 0}
                displayType={"text"}
                thousandSeparator={","}
                decimalSeparator="."
                decimalScale={0}
                suffix="%"
                fixedDecimalScale
              />
            )}
          </Link>
        </td>
      )}

      <td className="text-center">
        <Link className="LinkTable" to={`/ppto/${p.id}`}>
          <div className="row photo">
            <div className="col d-flex justify-content-center">
              <div className="d-flex justify-content-center align-items-center p-container-foto">
                <Tooltip
                  title={`${p.ejecutivo_nombre}${" "}${p.ejecutivo_apellidos}`}
                >
                  <span>
                    {p.ejecutivo_nombre
                      ? p.ejecutivo_nombre.substring(0, 1)
                      : ""}
                    {p.ejecutivo_apellidos
                      ? p.ejecutivo_apellidos.substring(0, 1)
                      : ""}
                  </span>
                </Tooltip>
              </div>
            </div>
          </div>
        </Link>
      </td>

      <td className="text-clientes text-center">
        <Link className="LinkTable" to={`/ppto/${p.id}`}>
          <span style={{ textTransform: "capitalize" }}>
            {p.creador_nombre ? p.creador_nombre : "--"}
          </span>
        </Link>
      </td>

      <td className="text-center">
        <Link className="LinkTable" to={`/ppto/${p.id}`}>
          {p.ult_modificacion || "Hace días"}
        </Link>
      </td>
    </tr>
  );
};
